module.exports = __webpack_public_path__ + "static/media/edit.f2108a98.svg";